<template>
	<div class="announcement-banner"
			 @click="dismiss()"
			 v-if="this.show"
			 title="Dismiss this message."
			 v-html="msg">
	</div>
</template>

<script>
export default {
  name: 'AnnouncementBanner',
  data () {
		return {
			show: true
		}
	},
	methods: {
		dismiss() { this.show = !this.show }
	},
  props: {
		msg: String
  }
}
</script>

<style lang="scss">
.announcement-banner {
		background-color: white;
		padding: 16px 0;
    position: relative;
    display: block;
    align-items: center;
    justify-content: center;
		border-radius: 0 0 3px 3px;
		cursor: pointer;
		font-size: 1em;
		color: #15a2fe;

		&:hover {
			background-color: #f5f5f5;
		}

		a {
			color: #15a2fe !important;
		}
}
</style>
